'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var murmur3 = require('@multiformats/murmur3');

var hamtHashCode = murmur3.murmur3128.code;
var hamtBucketBits = 8;

function hamtHashFn(_x) {
  return _hamtHashFn.apply(this, arguments);
}

function _hamtHashFn() {
  _hamtHashFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(buf) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return murmur3.murmur3128.encode(buf);

          case 2:
            return _context.abrupt("return", _context.sent.slice(0, 8).reverse());

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _hamtHashFn.apply(this, arguments);
}

exports.hamtBucketBits = hamtBucketBits;
exports.hamtHashCode = hamtHashCode;
exports.hamtHashFn = hamtHashFn;